export default (value, dec = 2) => {
  if (!value) return '';
  if (Number.isNaN(parseFloat(value))) return value;
  const string = String(value);
  if (string.endsWith('%')) {
    return `${Number.parseFloat(value).toFixed(dec)}%`;
  }
  return Number(value).toFixed(dec);
};
